import { Handle } from '../Canvas';
import { BranchNameWorkflow } from '../Workflows/BranchSettings/BranchNameWorkflow';

export const BranchNameNode = ({ id }) => {
  return (
    <>
      <Handle type="target" position={'top' as any} />
      <BranchNameWorkflow id={id} />
      <Handle type="source" position={'bottom' as any} />
    </>
  );
};
